// カート画面の .senderinput（お届け先の入力）の後ろに「複数のお届け先」の案内ページ（/page/924）へのリンクを足す。
// おちゃのこ「アクセス解析タグ設定」欄に直書きされていた <script defer> ブロックの引き取り先（Issue #60）。fukuro.in だけの機能。
//
// ★ 画像は旧ドメイン opp-fukuro.ocnk.net を指している。挙動を変えないため綴りをそのまま移す。
// ★ 旧実装の if(location.href.indexOf('/cart/')) は -1 でも true で実質いつも通っていた。hooks.ts の when で /cart/ に限定する。
// 過渡期におちゃのこ側の直書きと同居しても二重に出ないよう、同じ id のリンクが既にあれば何もしない
// （旧側はインラインの <script> なので、defer の storefront.js より必ず先に走る）。

export const MULTI_DELIVERY_LINK_ID = 'cart-multi-delivery-page'
export const MULTI_DELIVERY_PAGE = 'https://www.fukuro.in/page/924'
export const MULTI_DELIVERY_IMAGE = 'https://opp-fukuro.ocnk.net/data/opp-fukuro/image/es-help.png'

export function buildMultiDeliveryLink(doc: Document): HTMLAnchorElement {
  const a = doc.createElement('a')
  a.id = MULTI_DELIVERY_LINK_ID
  a.href = MULTI_DELIVERY_PAGE
  a.target = '_blank'
  const img = doc.createElement('img')
  img.src = MULTI_DELIVERY_IMAGE
  img.alt = '？'
  a.appendChild(img)
  return a
}

/** 足した本数。既に id があれば 0 */
export function insertMultiDeliveryLinks(root: ParentNode & { getElementById(id: string): Element | null }, doc: Document): number {
  if (root.getElementById(MULTI_DELIVERY_LINK_ID)) return 0
  const inputs = root.querySelectorAll('.senderinput')
  inputs.forEach((el) => el.after(buildMultiDeliveryLink(doc))) // 旧実装（jQuery .after）どおり要素ごとに足す
  return inputs.length
}

export default function cartMultiDelivery(): void {
  insertMultiDeliveryLinks(document, document)
}
